import { render } from "./CalendarNextIcon.vue?vue&type=template&id=06652a42"
import script from "./CalendarNextIcon.vue?vue&type=script&lang=js"
export * from "./CalendarNextIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__